module.exports = __webpack_public_path__ + "static/media/char-1.787f0063.svg";